<template>
<div>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        icon medium
        v-on="on"
        :loading="loading"
        class="btn-print mb-4"
        @click="getDropsData"
      >
        <v-col cols="12" class="btn-text">
          <v-icon color="#757575">local_printshop</v-icon>
          <span class="font-weight-bold">{{$t('print_files.export_packing_list')}}</span>
        </v-col>
      </v-btn>
    </template>
    <v-list v-if="loading === false && exportLoading === false">
      <v-list-item @click="exportPackingListPdf">
        <v-list-item-title>PDF</v-list-item-title>
      </v-list-item>
      <v-list-item @click="exportMultipleCsv">
        <v-list-item-title>CSV</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-snackbar
     v-if="exportLoading === true && loading === true"
     v-model="exportLoading"
     class="snackbar"
     color="#FB8C00"
    >
      Please wait
    </v-snackbar>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { dropHelpers, generalHelpers } from '@/_helpers'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Roboto from '@/assets/fonts/Roboto-Regular-normal.js'
import RobotoBold from '@/assets/fonts/Roboto-Bold-bold.js'
import * as Sentry from '@sentry/browser'

export default {
  name: 'ExportPackingList',
  components: {},
  props: {
    // selectedDrop: { type: Object, default: () => {} },
    // screenDetail: null
  },
  data () {
    return {
      loading: false,
      headOne: [],
      headTwo: [],
      bodyTwo: [],
      headThree: [],
      summaryHead: [],
      summaryBody: [],
      body: [],
      data: null,
      rows: [],
      rowsSummary: [],
      sortedArray: null
    }
  },
  computed: {
    ...mapGetters({ 
      getSelectedResourceID:'getSelectedResourceID',
      getSelectedResource: 'getSelectedResource',
      getDropAllUnits: 'getDropAllUnits',
      getDropTree: 'exportData/getDropTree', 
      getIsFetching: 'exportData/getIsFetching'}),
    ...mapGetters('cognito', ['userAttributes']),
    dropsData: function () {
      if (this.getSelectedResource) {
        return this.getDropTree(this.getSelectedResource.id)
      }
    },
    exportLoading: function () {
      return this.getIsFetching
    },
  },
  methods: {
    ...mapActions({ addDropUnits: 'exportData/addDropUnits', showSnackbar: 'showSnackbar' }),
    getDropsData () {
      if (this.dropsData.length === 0) {
        this.loading = true
        this.addDropUnits({ dropID: this.getSelectedResource.id})
      } else {
        this.loading = false
      }
    },
    addDocSettings (doc) {
      doc.addFileToVFS('Roboto-Regular.ttf', Roboto)
      doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold)
      doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
      doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')
      doc.setFont('Roboto')
    },
    exportPackingListPdf () {
      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf('landscape')
      // font to Roboto so we won't have problems with encoding
      this.addDocSettings(doc)

      doc.setFontSize(14)

      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('print_files.packing_list').toUpperCase(), 130, 10)
      doc.setFontStyle('normal')
      // doc.text(`${this.$i18n.t('print_files.delivery_date')}: ${this.$options.filters.dateToReadableFull(this.getDropDetails.arrival, this.$i18n.locale)}`, 116, 25)

      // first table with general info
      this.headOne = []
      this.headOne.push(
        [
          { content: `${this.$i18n.t('print_files.delivery_date')}: ${this.$options.filters.dateToReadableFull(this.getSelectedResource.arrival, this.$i18n.locale)}` },
          { content: ' ' }
        ],
        [
          { content: `${this.$i18n.t('print_files.from')}: ${this.getSelectedResource.origin.organization.name}` },
          { content: `${this.$i18n.t('print_files.customer')}: ${this.getSelectedResource.destination.organization.name}` }
        ],
        [
          { content: `${this.getSelectedResource.origin.address.street} ${this.getSelectedResource.origin.address.streetNo}` },
          { content: `${this.getSelectedResource.destination.address.street} ${this.getSelectedResource.destination.address.streetNo}` }
        ],
        [
          { content: `${this.getSelectedResource.origin.address.postalCode} ${this.getSelectedResource.origin.address.city}, ${this.getSelectedResource.origin.address.countryCode}` },
          { content: `${this.getSelectedResource.destination.address.postalCode} ${this.getSelectedResource.destination.address.city}, ${this.getSelectedResource.destination.address.countryCode}` }
        ]
      )

      // one table for all boxes outside pallet
      // it is outside the loop because we don't want it many times like in pallets

      let boxName, boxQuantity, boxWeight, boxDescription, boxDimensions, boxRef
      let boxUnits = []
      this.headTwo = []
      this.bodyTwo = []
      this.headThree = []
      this.headTwo.push(
        [
          { content: this.$i18n.t('print_files.units') },
          { content: this.$i18n.t('print_files.customer_order_reference') },
          { content: this.$i18n.t('print_files.description') },
          { content: this.$i18n.t('print_files.dimensions') }
        ]
      )

      this.headThree.push(
        [
          { content: this.$i18n.t('print_files.name') },
          { content: this.$i18n.t('print_files.units') },
          { content: this.$i18n.t('print_files.customer_order_reference') },
          { content: this.$i18n.t('print_files.description') },
          { content: this.$i18n.t('print_files.dimensions') + ' [CM]' },
          { content: this.$i18n.t('print_files.quantity') },
          { content: this.$i18n.t('print_files.weight') + ' [KG]' }
        ]
      )

      // second table with the data
      // body and headTwo are for table with pallets
      // bodyTwo and headThree are for table with boxes outside pallets
      for (let i = 0; i < this.dropsData.length; i++) {
        let quantity, weight
        if (this.dropsData[i].type === 'CustomBox') {
          try {
            if (this.dropsData[i].ref === null) {
              boxName = this.$i18n.t('packages_type.box')
            } else {
              boxName = `${this.$i18n.t('packages_type.box')}: ${this.dropsData[i].ref}`
            }
            boxQuantity = this.dropsData[i].items.length
            boxWeight = dropHelpers.calculateUnitWeight(this.dropsData[i])
            let roundedWeight = this.$options.filters.roundValueWeight(boxWeight, 0)
            boxDimensions = `${this.dropsData[i].dimensions.length} x ${this.dropsData[i].dimensions.width} x ${this.dropsData[i].dimensions.height}`
            // checks if customer refererce is empty or not
            if (this.dropsData[i].transport.order !== null) {
              boxRef = this.dropsData[i].transport.order.buyer.ref
            } else if (this.dropsData[i].transport.order === null) {
              boxRef = 'n/a'
            }
            for (let j = 0; j < this.dropsData[i].items.length; j++) {
              boxUnits = []
              boxUnits.push(this.dropsData[i].items[j].ref + '\n')
              // check if box description is not empty in data
              if (this.dropsData[i].items[j].name !== '') {
                boxDescription = this.dropsData[i].items[j].name
              } else if (this.dropsData[i].items[j].name === '') {
                boxDescription = '-'
              }
            }
            this.bodyTwo.push([boxName, boxUnits.join(''), boxRef, boxDescription, boxDimensions, boxQuantity, roundedWeight])
            // create the first table with general info
            doc.autoTable({
              head: this.headOne,
              styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
              headStyles: { fillColor: [246, 246, 246] },
              startY: 15
            })
          } catch (err) {
            Sentry.captureException(err)
            this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
            this.loading = false
          }
        } else if (this.dropsData[i].type === 'CustomPallet' || this.dropsData[i].type === 'EurPallet') {
          try {
            // sorts the array children by unit ascending
            this.sortedArray = this.dropsData[i].children
            for (let i = 0; i < this.sortedArray.length; i++) {
              for (let k = 0; k < this.sortedArray[i].items.length; k++) {
                this.sortedArray.sort((a, b) => (a.items[k].ref > b.items[k].ref) ? 1 : -1)
              }
            }
            // console.log(this.sortedArray)
            this.body = []
            for (let i = 0; i < this.sortedArray.length; i++) {
              let ref, dimensions, units, description
              // checks if customer reference is empty or not
              if (this.sortedArray[i].transport.order !== null) {
                ref = this.sortedArray[i].transport.order.buyer.ref
              } else if (this.sortedArray[i].transport.order === null) {
                ref = 'n/a'
              }
              dimensions = `${this.sortedArray[i].dimensions.length} x ${this.sortedArray[i].dimensions.width} x ${this.sortedArray[i].dimensions.height}`
              for (let k = 0; k < this.sortedArray[i].items.length; k++) {
                units = this.sortedArray[i].items[k].ref
                // check if box description is not empty
                if (this.sortedArray[i].items[k].name !== '') {
                  description = this.sortedArray[i].items[k].name
                } else if (this.sortedArray[i].items[k].name === '') {
                  description = '-'
                }
              }
              this.body.push([units, ref, description, dimensions])
            }
            // inside the loop to create a different table for each pallet
            // create the first table with general info
            doc.autoTable({
              head: this.headOne,
              styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
              headStyles: { fillColor: [246, 246, 246] },
              startY: 15
            })

            let finalY = doc.previousAutoTable.finalY

            quantity = this.dropsData[i].children.length
            weight = dropHelpers.calculateUnitWeight(this.dropsData[i])
            let roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
            doc.setFontSize(12)
            if (this.dropsData[i].ref === null) {
              doc.text(`${this.$i18n.t('packages_type.pallet')}   -   Dimensions: ${this.dropsData[i].dimensions.length} x ${this.dropsData[i].dimensions.width} x ${this.dropsData[i].dimensions.height} cm   -   Quantity: ${quantity}   -   Weight: ${roundedWeight} Kg`, 90, finalY + 10)
            } else {
              doc.text(`${this.$i18n.t('packages_type.pallet')}: ${this.dropsData[i].ref}   -   Dimensions: ${this.dropsData[i].dimensions.length} x ${this.dropsData[i].dimensions.width} x ${this.dropsData[i].dimensions.height} cm   -   Quantity: ${quantity}   -   Weight: ${roundedWeight} Kg`, 70, finalY + 10)
            }
            doc.setFontSize(14)
            // create the second table with pallet info
            doc.autoTable({
              startY: finalY + 15,
              head: this.headTwo,
              body: this.body,
              styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
              theme: 'grid',
              rowPageBreak: 'avoid',
              headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
              columnStyles: { 1: { overflow: 'ellipsize' }, 2: { overflow: 'ellipsize' } }
            })
            doc.addPage()
          } catch (err) {
            Sentry.captureException(err)
            this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
            this.loading = false
          }
        }
      }
      // outside the loop to create one table for all boxes outside pallet
      if (this.bodyTwo.length > 0) {
        doc.autoTable({
          head: this.headThree,
          body: this.bodyTwo,
          styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
          theme: 'grid',
          rowPageBreak: 'avoid',
          headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
          columnStyles: { 0: { cellWidth: 30 }, 1: { cellWidth: 40 }, 2: { cellWidth: 55, overflow: 'ellipsize' }, 3: { overflow: 'ellipsize' }, 5: { halign: 'right', cellWidth: 23 }, 6: { halign: 'right', cellWidth: 23 }, 4: { cellWidth: 32 } }
        })
        doc.addPage()
      }

      // Customer Summary table
      this.summaryHead = []
      this.summaryBody = []
      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('print_files.customer_summary').toUpperCase(), 130, 10)
      doc.setFontStyle('normal')
      let dropsAllBoxes = []
      let groupedObjects = []
      // console.log(this.dropsData)
      // if boxes outside pallet take them all
      // if pallet take the boxes inside children of pallet
      for (let i = 0; i < this.dropsData.length; i++) {
        if (this.dropsData[i].type === 'CustomBox') {
          dropsAllBoxes.push(this.dropsData[i])
        } else if (this.dropsData[i].type === 'CustomPallet' || this.dropsData[i].type === 'EurPallet') {
          dropsAllBoxes.push(...this.dropsData[i].children)
        }
      }
      // console.log(dropsAllBoxes)
      // takes all the boxes and groups them based on their customer ref number
      groupedObjects = generalHelpers.groupByObjects(dropsAllBoxes, 'transport.order.buyer.ref')
      let roundedVolume, groupedQuantity, customerRef, roundedWeight
      let weight = 0
      let volume = 0
      let groupedObjectsValues = Object.values(groupedObjects)
      // console.log(groupedObjectsValues)
      // console.log(groupedObjects)

      groupedObjectsValues.forEach((value) => {
        try {
          weight = 0
          volume = 0
          groupedQuantity = value.length
          // console.log(value)
          for (let i = 0; i < value.length; i++) {
            if (value[i].transport.order === null) {
              customerRef = 'n/a'
            } else if (value[i].transport.order !== null) {
              customerRef = value[i].transport.order.buyer.ref
            }
            if (value.length === 1) {
              volume = ((value[i].dimensions.length * value[i].dimensions.width * value[i].dimensions.height) * 0.000001)
              roundedVolume = this.$options.filters.roundValue(volume, 1)
              value[i].items.forEach((item) => {
                weight = parseInt(item.weight)
                roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
              })
            } else if (value.length > 1) {
              volume += ((value[i].dimensions.length * value[i].dimensions.width * value[i].dimensions.height) * 0.000001)
              roundedVolume = this.$options.filters.roundValue(volume, 1)
              value[i].items.forEach((item) => {
              // because the method roundValueWeight makes the number into a string
              // I use parseInt to change it back into a number to add them together
              weight += parseInt(item.weight)
              roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
              })
            }
          }
          this.summaryBody.push([customerRef, roundedWeight, roundedVolume, groupedQuantity])
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      })
      this.summaryHead.push(
        [
          { content: this.$i18n.t('print_files.customer_order_reference') },
          { content: this.$i18n.t('print_files.weight') + ' [KG]' },
          { content: this.$i18n.t('print_files.volume') + ' [CBM]' },
          { content: this.$i18n.t('print_files.boxes') }
        ]
      )
      doc.autoTable({
        head: this.headOne,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        headStyles: { fillColor: [246, 246, 246] },
        startY: 15
      })
      doc.autoTable({
        head: this.summaryHead,
        body: this.summaryBody,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
        columnStyles: { 1: { halign: 'right' }, 2: { halign: 'right' }, 3: { halign: 'right' } },
        theme: 'grid',
        rowPageBreak: 'avoid'
      })

      let pageCount = doc.internal.getNumberOfPages()
      let dateObj = new Date()
      let day = dateObj.getDate()
      // months in js are indexed from 0
      let month = dateObj.getMonth() + 1
      let year = dateObj.getFullYear()
      let hour = dateObj.getHours()
      // adds 0 in front of minutes when needed
      let minute = String(dateObj.getMinutes()).padStart(2, '0')
      let newDate = day + '/' + month + '/' + year
      let newTime = hour + ':' + minute
      // if there are only pallets and no boxes delete the last blank page that is created
      // if (this.bodyTwo.length === 0) {
      //   doc.deletePage(pageCount)
      // }
      for (let i = 0; i < pageCount; i++) {
        doc.setFontSize(14)
        doc.setPage(i)
        doc.text(259, 10, this.$i18n.t('print_files.pages') + ': ' + doc.internal.getCurrentPageInfo().pageNumber + '/' + pageCount)
        doc.setFontSize(9)
        doc.text(14, 203, `${this.$i18n.t('print_files.printed')} ${newDate} ${this.$i18n.t('print_files.at')} ${newTime} ${this.$i18n.t('print_files.by')} ${this.userAttributes.email}`)
        doc.text(244, 203, this.$i18n.t('print_files.generated'))
      }
      try {
        doc.save(`${this.$i18n.t('print_files.packing_list_file_name')}.pdf`)
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.loading = false
    },
    exportPackingListCsv () {
      this.loading = true
      this.rows = []
      let csvContent = 'data:text/csv;charset=utf-8,'
      this.rows.push([this.$i18n.t('print_files.name') + ' & ' + this.$i18n.t('print_files.size') + ' [CM]', this.$i18n.t('print_files.units'), this.$i18n.t('print_files.customer_order_reference'), this.$i18n.t('print_files.description'), this.$i18n.t('print_files.dimensions') + ' [CM]', this.$i18n.t('print_files.quantity'), this.$i18n.t('print_files.weight') + ' [KG]'])

      for (let i = 0; i < this.dropsData.length; i++) {
        try {
          let name, quantity, weight, description, dimensions, ref
          let units = []
          let descriptionPallet = []
          let refPallet = []
          let dimensionsPallet = []

          if (this.dropsData[i].type === 'CustomBox') {
            name = this.$i18n.t('packages_type.box')
            if (this.dropsData[i].ref === null) {
              name = this.$i18n.t('packages_type.box')
            } else {
              name = `${this.$i18n.t('packages_type.box')}: ${this.dropsData[i].ref}`
            }
            quantity = this.dropsData[i].items.length
            weight = dropHelpers.calculateUnitWeight(this.dropsData[i])
            let roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
            dimensions = `${this.dropsData[i].dimensions.length} x ${this.dropsData[i].dimensions.width} x ${this.dropsData[i].dimensions.height}`
            // checks if customer reference is empty
            if (this.dropsData[i].transport.order !== null) {
              ref = this.dropsData[i].transport.order.buyer.ref
            } else if (this.dropsData[i].transport.order === null) {
              ref = 'n/a'
            }
            for (let j = 0; j < this.dropsData[i].items.length; j++) {
              units = []
              units.push(this.dropsData[i].items[j].ref)
              if (this.dropsData[i].items[j].name !== '') {
                description = this.dropsData[i].items[j].name
              } else if (this.dropsData[i].items[j].name === '') {
                description = '-'
              }
            }
            this.rows.push([name, units, ref, description, dimensions, quantity, roundedWeight])
          } else if (this.dropsData[i].type === 'CustomPallet' || this.dropsData[i].type === 'EurPallet') {
            this.sortedArray = this.dropsData[i].children
            for (let i = 0; i < this.sortedArray.length; i++) {
              for (let k = 0; k < this.sortedArray[i].items.length; k++) {
                this.sortedArray.sort((a, b) => (a.items[k].ref > b.items[k].ref) ? 1 : -1)
              }
            }
            // check if the pallet has a name
            if (this.dropsData[i].ref === null) {
              name = `${this.$i18n.t('packages_type.pallet')}-${this.dropsData[i].dimensions.length}x${this.dropsData[i].dimensions.width}x${this.dropsData[i].dimensions.height}`
            } else {
              name = `${this.$i18n.t('packages_type.pallet')}: ${this.dropsData[i].ref}-${this.dropsData[i].dimensions.length}x${this.dropsData[i].dimensions.width}x${this.dropsData[i].dimensions.height}`
            }
            quantity = this.dropsData[i].children.length
            weight = dropHelpers.calculateUnitWeight(this.dropsData[i])
            let roundedWeight = this.$options.filters.roundValueWeight(weight, 0)

            for (let i = 0; i < this.sortedArray.length; i++) {
              // checks if customer reference is empty or not
              if (this.sortedArray[i].transport.order !== null) {
                refPallet.push(this.sortedArray[i].transport.order.buyer.ref)
              } else if (this.sortedArray[i].transport.order === null) {
                refPallet.push('n/a' + '\n')
              }
              dimensionsPallet.push(`${this.sortedArray[i].dimensions.length} x ${this.sortedArray[i].dimensions.width} x ${this.sortedArray[i].dimensions.height}`)
              for (let k = 0; k < this.sortedArray[i].items.length; k++) {
                units.push(this.sortedArray[i].items[k].ref)
                // check if box description is not empty
                if (this.sortedArray[i].items[k].name !== '') {
                  descriptionPallet.push(this.sortedArray[i].items[k].name)
                } else if (this.sortedArray[i].items[k].name === '') {
                  descriptionPallet.push('-')
                }
              }
            }
            this.rows.push([name, units, refPallet, descriptionPallet, dimensionsPallet, quantity, roundedWeight])
          }
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      }
      this.rows.forEach(function (rowArray) {
        let row = rowArray.join(';').replace(',', '-')
        csvContent += row + '\r\n'
      })
      try {
        let encodedUri = encodeURI(csvContent)
        let link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `${this.$i18n.t('print_files.packing_list_file_name')}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
    },
    exportCustomerSummaryCsv () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      let dropsAllBoxes = []
      let groupedObjects = []
      this.rowsSummary = []
      // console.log(this.dropsData)
      // if boxes outside pallet take them all
      // if pallet take the boxes inside children of pallet
      for (let i = 0; i < this.dropsData.length; i++) {
        if (this.dropsData[i].type === 'CustomBox') {
          dropsAllBoxes.push(this.dropsData[i])
        } else if (this.dropsData[i].type === 'CustomPallet' || this.dropsData[i].type === 'EurPallet') {
          dropsAllBoxes.push(...this.dropsData[i].children)
        }
      }
      // console.log(dropsAllBoxes)
      // takes all the boxes and groups them based on their customer ref number
      groupedObjects = generalHelpers.groupByObjects(dropsAllBoxes, 'transport.order.buyer.ref')
      let roundedVolume, groupedQuantity, customerRef, roundedWeight
      let weight = 0
      let volume = 0
      let groupedObjectsValues = Object.values(groupedObjects)
      // console.log(groupedObjectsValues)
      this.rowsSummary.push([this.$i18n.t('print_files.customer_order_reference'), this.$i18n.t('print_files.weight') + ' [KG]', this.$i18n.t('print_files.volume') + ' [CBM]', this.$i18n.t('print_files.boxes')])

      groupedObjectsValues.forEach((value) => {
        try {
          weight = 0
          volume = 0
          groupedQuantity = value.length
          // console.log(value)
          for (let i = 0; i < value.length; i++) {
            if (value[i].transport.order === null) {
              customerRef = 'n/a'
            } else if (value[i].transport.order !== null) {
              customerRef = value[i].transport.order.buyer.ref
            }
            if (value.length === 1) {
              volume = ((value[i].dimensions.length * value[i].dimensions.width * value[i].dimensions.height) * 0.000001)
              roundedVolume = this.$options.filters.roundValue(volume, 1)
              value[i].items.forEach((item) => {
                weight = parseInt(item.weight, 0)
                roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
              })
            } else if (value.length > 1) {
              volume += ((value[i].dimensions.length * value[i].dimensions.width * value[i].dimensions.height) * 0.000001)
              roundedVolume = this.$options.filters.roundValue(volume, 1)
              value[i].items.forEach((item) => {
              // because the method roundValueWeight makes the number into a string
              // I use parseInt to change it back into a number to add them together
                weight += parseInt(item.weight, 0)
                roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
              })
            }
          }
          this.rowsSummary.push([customerRef, roundedWeight, roundedVolume, groupedQuantity])
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      })
      this.rowsSummary.forEach(function (rowArray) {
        let row = rowArray.join(';').replace(',', '-')
        csvContent += row + '\r\n'
      })
      try {
        let encodedUri = encodeURI(csvContent)
        let link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `${this.$i18n.t('print_files.customer_summary_file_name')}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
    },
    exportMultipleCsv () {
      this.exportPackingListCsv()
      this.exportCustomerSummaryCsv()
    }
  },
  created () {},
  watch: {
    dropsData (value) {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-print:before {
    display: none;
  }
  .btn-text {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  span {
    font-size: 12px;
    // font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #202020;
  }
  .snackbar {
    z-index: 1000;
    position: absolute;
    top: 80px;
  }
</style>
